module.exports = __webpack_public_path__ + "img/light-bulb2.c8ad5a46.svg";